import { render, staticRenderFns } from "./ui-button.vue?vue&type=template&id=4ff5200e&scoped=true&"
import script from "./ui-button.vue?vue&type=script&lang=ts&"
export * from "./ui-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff5200e",
  null
  
)

export default component.exports